import React, { useEffect } from "react";

const IndeterminateCheckbox = React.forwardRef(({ indeterminate, disabled, style = {}, ...rest }, ref) => {
  const defaultRef = React.useRef();
  const resolvedRef = ref || defaultRef;

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return (
    <>
      <input type="checkbox" ref={resolvedRef} disabled={disabled} style={{ ...style, cursor: disabled ? "not-allowed" : style.cursor }} {...rest} />
    </>
  );
});

export default IndeterminateCheckbox;
